// extracted by mini-css-extract-plugin
export default {"topBar":"Card_topBar__oc1lx","titleBlock":"Card_titleBlock__hyE7E"};